import { csColorBackground, csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { CSSResult, css } from 'lit'

export const columnMenuStyle = {
  minWidth: css`var(--csc-column-menu-min-width, 150px)`,
  borderWidth: css`var(--csc-column-menu-border-width, ${csSpacing.spacing00})`,
  borderColor: css`var(--csc-column-menu-border-color, ${csColorBorder.light})`,
  borderColorInactive: css`var(--csc-column-menu-border-color-inactive, ${csColorBackground.secondary})`,
  firstColumnWidth: css`var(--csc-column-menu-first-column-width, 250px)`,
}

export const style: CSSResult = css`
  .container {
    display: grid;
    grid-template-columns: ${columnMenuStyle.firstColumnWidth} repeat(
      calc(var(--csc-column-menu-max-depth, 5) - 1),
      1fr
    );
  }

  .container.with-image {
    grid-template-columns: ${columnMenuStyle.firstColumnWidth} repeat(
      var(--csc-column-menu-max-depth, 5),
      1fr
    );
  }

  .container.with-image .image-wrapper {
    grid-column: calc(var(--csc-column-menu-max-depth, 5) + 1);
    display: flex;
    padding-inline: ${csSpacing.spacing06};
  }

  .column-wrapper {
    min-width: ${columnMenuStyle.minWidth};
    border-right-width: ${columnMenuStyle.borderWidth};
    border-right-style: solid;
    border-right-color: ${columnMenuStyle.borderColor};
    box-sizing: border-box;
  }

  .column-wrapper:last-child {
    border-right-color: ${columnMenuStyle.borderColorInactive};
  }
`
